export default "assets/images/icons/arrow-right-21d58050.svg";